"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var sizes = ['small', 'medium'];

var EditIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(EditIcon, _React$PureComponent);

  function EditIcon() {
    _classCallCheck(this, EditIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(EditIcon).apply(this, arguments));
  }

  _createClass(EditIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["size", "color", "className"]);
      /* eslint-disable max-len */


      var svgs = {
        small: {
          viewBox: '0 0 8 8',
          // TODO: path is not the right one, it's a temporary version
          // based on the medium one shrinked to 8x8
          // need to pick the exact unique shape once provided by the design team
          path: _react.default.createElement("g", null, _react.default.createElement("path", {
            fill: color,
            d: "M6.45000715,0.608595482 L7.39281619,1.55140452 C7.65316572,1.81175405 7.65316572,2.23386404 7.39281619,2.49421357 L3.21999995,6.67333349 L1.33333333,4.78666655 L5.50719811,0.608595482 C5.76754763,0.348245955 6.18965762,0.348245955 6.45000715,0.608595482 Z"
          }), _react.default.createElement("path", {
            fill: color,
            d: "M0.793152898,5.32264069 L2.67877098,7.20825877 L0.812038715,7.58160523 C0.631518797,7.61770921 0.455910428,7.50063696 0.419806445,7.32011705 C0.411175634,7.27696299 0.411175634,7.23252701 0.419806445,7.18937296 L0.793152898,5.32264069 Z"
          }))
        },
        medium: {
          viewBox: '0 0 12 12',
          path: _react.default.createElement("path", {
            fill: color,
            d: "M9.67501072,0.912893224 L11.0892243,2.32710679 C11.4797486,2.71763108 11.4797486,3.35079606 11.0892243,3.74132035 L4.82999992,10.0100002 L2,7.17999983 L8.26079716,0.912893224 C8.65132145,0.522368932 9.28448643,0.522368932 9.67501072,0.912893224 Z M1.18972935,7.98396104 L4.01815647,10.8123882 L1.21805807,11.3724078 C0.947278196,11.4265638 0.683865642,11.2509554 0.629709667,10.9801756 C0.616763451,10.9154445 0.616763451,10.8487905 0.629709667,10.7840594 L1.18972935,7.98396104 Z"
          })
        }
      };
      /* eslint-enable max-len */

      var svg = svgs[size];
      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'edit-icon'),
        viewBox: svg.viewBox,
        size: size
      }, props), svg.path);
    }
  }]);

  return EditIcon;
}(_react.default.PureComponent);

exports.default = EditIcon;
EditIcon.defaultProps = {
  size: 'medium',
  color: 'inherit'
};
EditIcon.propTypes = {
  size: _propTypes.default.oneOf(sizes),
  className: _propTypes.default.string,
  color: _propTypes.default.string
};